var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-management-container" },
    [
      _c("SearchLabels", {
        attrs: {
          triggerSearchLabel: _vm.searchUsers,
          setTextValue: _vm.setTextValue,
          placeholder: `${_vm.$t("managementLabels.placeholder")}`
        }
      }),
      _c("div", { staticClass: "table-container" }, [
        _c("table", [
          _c("thead", [
            _c(
              "tr",
              { staticClass: "row" },
              _vm._l(_vm.table?.headers, function(header, index) {
                return _c(
                  "th",
                  {
                    key: index,
                    class: [
                      "column",
                      { "sticky-column": index === 0 },
                      { unclickable: header.key === "actions" }
                    ],
                    on: {
                      click: function($event) {
                        return _vm.setNewOrder(header.key)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.$t(`${header.name}`)) + " "),
                    header.key === _vm.criteria.sort[0].by
                      ? _c("img", {
                          class:
                            _vm.criteria.sort[0].order === "ASC"
                              ? "rotated"
                              : "",
                          attrs: {
                            src: require("@/drc/assets/icons/arrow-down-white.svg"),
                            alt: "sort"
                          }
                        })
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ]),
          _c(
            "tbody",
            _vm._l(_vm.table.rows, function(row, index) {
              return _c(
                "tr",
                { key: index, staticClass: "row" },
                [
                  _vm._l(
                    _vm.table.headers.filter(h => h.key !== "actions"),
                    function(header, indexRow) {
                      return _c("td", {
                        key: indexRow,
                        class: [
                          "column",
                          `column-${indexRow}`,
                          { "sticky-column": indexRow === 0 },
                          {
                            "status-pending":
                              header.key === "status" &&
                              row[header.key] === "PENDING"
                          },
                          {
                            "status-approved":
                              header.key === "status" &&
                              row[header.key] === "APPROVED"
                          }
                        ],
                        domProps: {
                          innerHTML: _vm._s(
                            `<div class='td-div'>${_vm.getText(
                              row[header.key],
                              header.key
                            )}</div>`
                          )
                        },
                        on: {
                          mouseover: function($event) {
                            return _vm.hoverIn(index, indexRow)
                          },
                          mouseout: function($event) {
                            return _vm.hoverOut(index, indexRow)
                          }
                        }
                      })
                    }
                  ),
                  _c("td", [
                    _c("div", [
                      row["status"] === "PENDING"
                        ? _c(
                            "button",
                            {
                              staticClass: "approve",
                              on: {
                                click: function($event) {
                                  return _vm.approveUser(row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "controlPanel.usersManagement.approve"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : row["status"] === "APPROVED"
                        ? _c(
                            "button",
                            {
                              staticClass: "pending",
                              on: {
                                click: function($event) {
                                  return _vm.setPending(row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "controlPanel.usersManagement.setToPending"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _c("div", [
                      row["status"] === "PENDING" ||
                      row["status"] === "APPROVED"
                        ? _c(
                            "button",
                            {
                              staticClass: "halt",
                              on: {
                                click: function($event) {
                                  return _vm.setHalted(row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "controlPanel.usersManagement.setToHalted"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : row["status"] === "HALTED"
                        ? _c(
                            "button",
                            {
                              staticClass: "halt",
                              on: {
                                click: function($event) {
                                  return _vm.setUnhalted(row)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "controlPanel.usersManagement.setToUnhalted"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ],
                2
              )
            }),
            0
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }